/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SurveyNeedingApprovalModel } from '../../models/survey-needing-approval-model';

export interface GetSurveysNeedingApprovalReport$Json$Params {

/**
 * filter by clientrep id. optional
 */
  clientRepId?: number;
}

export function getSurveysNeedingApprovalReport$Json(http: HttpClient, rootUrl: string, params?: GetSurveysNeedingApprovalReport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SurveyNeedingApprovalModel>>> {
  const rb = new RequestBuilder(rootUrl, getSurveysNeedingApprovalReport$Json.PATH, 'get');
  if (params) {
    rb.query('clientRepId', params.clientRepId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SurveyNeedingApprovalModel>>;
    })
  );
}

getSurveysNeedingApprovalReport$Json.PATH = '/api/Report/SurveysNeedingApproval';
